// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2981bb4","239":"83c0fb01","453":"1c89c5f4","732":"4c763c67"}[chunkId] + ".chunk.js";
};